import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import { DynamicHeightContainer } from "@ep/react-components";
import RoundCaption from "./RoundCaption";
import styles from "../../styles/collapsible.module.scss";

class Collapsible extends React.Component {
  static propTypes = {
    expandable: PropTypes.bool
  };

  static defaultProps = {
    expandable: true
  };

  constructor(props) {
    super(props);
    this.state = {
      collapsed: true
    };

    this.handleCollapse = this.handleCollapse.bind(this);
    this.handleExpand = this.handleExpand.bind(this);
    this.dhcRef = React.createRef();
  }

  componentDidMount() {
    // this is ugly hack, but I don't know how to fix it fast
    // the problem is that it has wrong height calculated for inner container
    // and it looks cutted, after expanding/collapsing everything is back to normal
    // so here I manually force this component to recalculate its height
    _.defer(this.dhcRef.current.updateContainerHeight);
  }

  handleCollapse() {
    if (this.props.expandable) this.setState({ collapsed: true });
  }

  handleExpand() {
    if (this.props.expandable) this.setState({ collapsed: false });
  }

  render() {
    const [Caption, Content] = this.props.children;
    const { collapsed } = this.state;
    const containerClass = collapsed
      ? styles.collapsibleContainer
      : styles.collapsibleContainerExpanded;
    const toggleClass = collapsed
      ? styles.collapsibleContainerToggle
      : styles.collapsibleContainerToggleExpanded;

    return (
      <DynamicHeightContainer ref={this.dhcRef}>
        <div className={containerClass}>
          <RoundCaption>
            <div
              className={styles.collapsibleCaption}
              onClick={collapsed ? this.handleExpand : this.handleCollapse}
            >
              <div className={styles.collapsibleCaptionContent}>{Caption}</div>
              <div className={toggleClass}>
                {this.props.expandable && (
                  <button className={collapsed ? "collapsed" : "expanded"} />
                )}
              </div>
            </div>
          </RoundCaption>
          {this.state.collapsed ? null : (
            <div className={styles.collapsibleContainerContent}>{Content}</div>
          )}
        </div>
      </DynamicHeightContainer>
    );
  }
}

export default Collapsible;
